import { render, staticRenderFns } from "./liveVikiCR.container.vue?vue&type=template&id=705f0df7&scoped=true&"
import script from "./liveVikiCR.container.vue?vue&type=script&lang=js&"
export * from "./liveVikiCR.container.vue?vue&type=script&lang=js&"
import style0 from "./liveVikiCR.container.vue?vue&type=style&index=0&id=705f0df7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705f0df7",
  null
  
)

export default component.exports